import { apiRequest } from "./client";

async function handleResponse(response) {
  if (!response.ok) {
    if (response.status === 204) {
      return;
    }
    let errorDetail = `サーバーエラー: ${response.status}`;
    try {
      const errorJson = await response.json();
      errorDetail = errorJson.detail || errorDetail;
    } catch (e) {
      errorDetail = (await response.text()) || errorDetail;
    }
    throw new Error(errorDetail);
  }
  if (response.status === 204) {
    return;
  }
  return response.json();
}

export async function getFolders() {
  const response = await apiRequest(`/api/v1/folders`);
  return handleResponse(response);
}

export async function createFolder(name) {
  const response = await apiRequest(`/api/v1/folders`, {
    method: "POST",
    body: JSON.stringify({ name }),
  });
  return handleResponse(response);
}

export async function updateFolder(folderPublicId, name) {
  const response = await apiRequest(`/api/v1/folders/${folderPublicId}`, {
    method: "PATCH",
    body: JSON.stringify({ name }),
  });
  return handleResponse(response);
}

export async function deleteFolder(folderPublicId) {
  const response = await apiRequest(`/api/v1/folders/${folderPublicId}`, {
    method: "DELETE",
  });
  return handleResponse(response);
}
